import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-75e8480a")

_pushScopeId("data-v-75e8480a")
const _hoisted_1 = {
  key: 0,
  class: "not-finished-container"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "empty-box" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "empty-tips" }, [
  /*#__PURE__*/_createVNode("span", null, "产品研发中")
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "empty-tips-big" }, [
  /*#__PURE__*/_createVNode("span", null, "敬请期待...")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "知道了", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.show)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _createVNode("div", {
          class: "not-finished-back",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.popClose && _ctx.popClose(...args)))
        }, [
          _hoisted_5
        ])
      ]))
    : _createCommentVNode("", true)
})